// Script para bloquear enlaces en el área del carrusel
console.log("=== SWIPER LINK BLOCKER LOADED ===");

function blockProductLinksInSwiper() {
  // Buscar todos los carruseles
  const swiperContainers = document.querySelectorAll('.product-card-swiper');
  
  swiperContainers.forEach((swiper, index) => {
    console.log(`Blocking links for swiper ${index + 1}`);
    
    // Bloquear clicks SOLO si NO son en botones de navegación
    swiper.addEventListener('click', (e) => {
      // Verificar si el click es en un botón de navegación o paginación
      const isNavigationButton = e.target.closest('.swiper-button-next') || 
                                 e.target.closest('.swiper-button-prev') || 
                                 e.target.closest('.swiper-pagination');
      
      if (!isNavigationButton) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Swiper click blocked (not navigation)');
      } else {
        console.log('Navigation button clicked - allowing');
      }
    }, true);
    
    // Encontrar el contenedor padre de la card
    const cardWrapper = swiper.closest('.card-wrapper');
    if (cardWrapper) {
      // Bloquear específicamente los enlaces del producto en esta card
      const productLinks = cardWrapper.querySelectorAll('a.full-unstyled-link');
      productLinks.forEach(link => {
        // Solo bloquear si el enlace está en el área de la imagen
        const cardMedia = link.closest('.card__media');
        if (cardMedia) {
          link.style.pointerEvents = 'none';
          console.log('Product link blocked in image area');
        }
      });
    }
  });
}

// Ejecutar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', blockProductLinksInSwiper);
} else {
  blockProductLinksInSwiper();
}

// También ejecutar después de un delay para asegurar que todo esté cargado
setTimeout(blockProductLinksInSwiper, 1000);
setTimeout(blockProductLinksInSwiper, 3000);

// Ejecutar cuando se carguen nuevas secciones
window.addEventListener('shopify:section:load', () => {
  setTimeout(blockProductLinksInSwiper, 100);
});